import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Send } from "lucide-react";

export const Newsletter = ({ inverse = false }) => {
  const [email, setEmail] = useState("");
  const [nombre, setNombre] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email, nombre });
      toast.success(data.already ? "Ya estabas en la lista. Nos alegra tenerte." : "Bienvenida a la Carta desde la Cometa.");
      setEmail(""); setNombre("");
    } catch {
      toast.error("No pudimos suscribirte. Intenta de nuevo.");
    } finally { setLoading(false); }
  };

  return (
    <section className={`${inverse ? "bg-cometa-marino text-cometa-crema" : "bg-cometa-crema text-cometa-tinta"} relative overflow-hidden`}>
      <div className="max-w-4xl mx-auto px-6 py-20 lg:py-28 text-center">
        <p className={`font-script text-4xl md:text-5xl ${inverse ? "text-cometa-dorado" : "text-cometa-marino"} mb-3`}>
          Carta desde la Cometa
        </p>
        <h2 className="text-3xl md:text-5xl mb-5">Recibe conversaciones que valen la pena.</h2>
        <p className={`max-w-2xl mx-auto text-lg ${inverse ? "text-cometa-crema/75" : "text-cometa-tinta/70"} mb-10`}>
          Historias, preguntas, invitaciones y utopías. Escribimos cuando hay algo que compartir.
        </p>
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-2xl mx-auto">
          <input
            type="text"
            placeholder="Tu nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            className={`flex-1 px-5 py-4 rounded-full border ${inverse ? "bg-cometa-marino/40 border-cometa-crema/20 placeholder-cometa-crema/50 text-cometa-crema" : "bg-white border-cometa-tinta/15"} focus:outline-none focus:ring-2 focus:ring-cometa-dorado`}
            data-testid="newsletter-name"
          />
          <input
            type="email"
            required
            placeholder="tu@correo.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={`flex-1 px-5 py-4 rounded-full border ${inverse ? "bg-cometa-marino/40 border-cometa-crema/20 placeholder-cometa-crema/50 text-cometa-crema" : "bg-white border-cometa-tinta/15"} focus:outline-none focus:ring-2 focus:ring-cometa-dorado`}
            data-testid="newsletter-email"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="newsletter-submit"
            className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-cometa-dorado text-cometa-tinta font-semibold hover:bg-cometa-carmesi hover:text-white transition disabled:opacity-60"
          >
            {loading ? "Enviando..." : (<>Súmate <Send size={16} /></>)}
          </button>
        </form>
      </div>
    </section>
  );
};
